module.exports = __webpack_public_path__ + "user/static/media/logo-white.fa22ba93.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Logo/logo-white.png
// module id = 312
// module chunks = 38